import { forwardRef, type ReactNode, type SelectHTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-10 w-full appearance-none rounded-lg border border-border-default bg-bg-overlay/50 px-3 pr-10 py-2 text-sm text-text-primary',
        'transition-[border-color,box-shadow] duration-150',
        'focus-visible:outline-none focus-visible:border-accent/60 focus-visible:ring-2 focus-visible:ring-accent/20 focus-visible:bg-bg-overlay',
        'hover:border-border-default/80',
        'disabled:cursor-not-allowed disabled:opacity-50',
        '[color-scheme:dark]',
        'bg-no-repeat',
        className,
      )}
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
        backgroundPosition: 'right 10px center',
        backgroundSize: '12px',
      }}
      {...props}
    >
      {children}
    </select>
  ),
)
Select.displayName = 'Select'
